// const data = Fetch(2);
export 
// const formIoData = Fetch(2);
const formIoData = {
  
  display: "form",
  components: 
  [

    // {
    //   label: "Text Field",
    //   tableView: true,
    //   validate: {
    //     // pattern: "/^([A-Z][a-z .'-]*)*$/",
    //     customMessage: "Test error",
    //     // "custom": "valid = (input !== 'Joe')",
    //     minLength: 3,
    //     maxLength: 10
    //   },
    //   errorLabel: "Please fill in only letters.",
    //   key: "textField",
    //   type: "textfield",
    //   input: true
    // },
    // {
    //   label: "Checkbox",
    //   tableView: false,
    //   key: "checkbox",
    //   type: "checkbox",
    //   input: true
    // },
    // {
    //   "label": "Upload",
    //   "tableView": false,
    //   "storage": "googledrive",
    //   "webcam": false,
    //   "fileTypes": [
    //     {
    //       "label": "mp4",
    //       "value": ""
    //     }
    //   ],
    //   "validateWhenHidden": false,
    //   "key": "file",
    //   "type": "file",
    //   "input": true,
    // },
    // {
    //   type: "button",
    //   label: "Submit",
    //   key: "submit",
    //   disableOnInvalid: true,
    //   input: true,
    //   tableView: false
    // }
  ]
};
